import { VoipPhoneNumberToCallSection } from './VoipPhoneNumberToCallSection';
import { VoipPhoneCallSettingsSection } from './VoipPhoneCallSettingsSection';

export const VoipPhoneTestConfigSection = () => {
    return (
        <>
            <VoipPhoneNumberToCallSection />
            <VoipPhoneCallSettingsSection />
        </>
    );
};
